import React from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import BackArrowButton from "../parts/back-arrow-button";
import LoginWrapper from "./LoginWrapper";
import Select from "../parts/inputs/select";

function View(props) {
  const { t } = useTranslation("auth");
  const [whatDescribesYou, setwhatDescribesYou] = React.useState(
    t("feedback.optionFuture")
  );
  const handleReturnButton = (e) => {
    e?.preventDefault?.();
    submit("coach-billing", {
      method: "GET",
    });
  };

  return (
    <LoginWrapper
      mainClass="Billing feedback"
      left={
        <form
          method="POST"
          action="/actions/user/user-denied-signup"
          data-noreset
        >
          <BackArrowButton
            onBack={(e) => handleReturnButton(e)}
            text=""
            classNames="mobile-hidden"
          />

          <section className="mobile-hidden">
            <h2 className="clipped w-fit ml-auto mr-auto">
              {t("feedback.title")}
            </h2>
            <p className="text-center mt-3">{t("feedback.intro")}</p>
          </section>

          <header className="only-show-mobile">
            <section>
              <BackArrowButton onBack={(_) => handleReturnButton()} />

              <h2 className="clipped text-center">{t("feedback.title")}</h2>
            </section>
            <p className="text-center mt-3">{t("feedback.intro")}</p>
          </header>

          <section>
            <label htmlFor="whatDescribesYou">
              {t("feedback.whatDescribesYou")}
            </label>
            <Select
              name="whatDescribesYou"
              value={whatDescribesYou}
              onChange={setwhatDescribesYou}
              options={[
                {
                  value:
                    "I am not signing up now, but will definitely in the future",
                  label: t("feedback.optionFuture"),
                },
                {
                  value: "I am not signing up now, but may try in the future",
                  label: t("feedback.optionMaybe"),
                },
                {
                  value: "I am never signing up",
                  label: t("feedback.optionNever"),
                },
              ]}
            />

            <div className="checkboxes-wrapper">
              <div className="feedback-checkboxes">
                <label htmlFor="whyNotSignup">
                  {t("feedback.whyNotSignup")}
                </label>
                <div>
                  <input
                    type="checkbox"
                    name="whyNotSignup"
                    value="Too expensive"
                  />
                  <span className="text">{t("feedback.tooExpensive")}</span>
                </div>

                <div>
                  <input
                    type="checkbox"
                    name="whyNotSignup"
                    value="Too buggy"
                  />
                  <span className="text">{t("feedback.tooBuggy")}</span>
                </div>

                <div>
                  <input
                    type="checkbox"
                    name="whyNotSignup"
                    value="Too confusing to use/learn "
                  />
                  <span className="text">{t("feedback.tooConfusing")}</span>
                </div>

                <div>
                  <input
                    type="checkbox"
                    name="whyNotSignup"
                    value="Doesnt have the features I needwat"
                  />
                  <span className="text">{t("feedback.noFeatures")}</span>
                </div>

                <div>
                  <input
                    type="checkbox"
                    name="whyNotSignup"
                    value="Not as good as an alternative"
                  />
                  <span className="text">{t("feedback.notGoodEnough")}</span>
                </div>

                <div>
                  <input
                    type="checkbox"
                    name="whyNotSignup"
                    value="Did not work the way I expected"
                  />
                  <span className="text">{t("feedback.didNotWork")}</span>
                </div>

                <div>
                  <input
                    type="checkbox"
                    name="whyNotSignup"
                    value="Other (please specify below)"
                  />
                  <span className="text">{t("feedback.otherOption")}</span>
                </div>
              </div>

              <div className="feedback-input">
                <label htmlFor="details">{t("feedback.moreDetails")}</label>
                <textarea
                  name="details"
                  placeholder={t("feedback.detailsPlaceholder")}
                ></textarea>
              </div>
            </div>
          </section>

          <footer>
            <button
              data-button-type="primary"
              sz="large"
              className="px-10 w-1/2! mobile-hidden"
              type="submit"
            >
              {t("feedback.continue")}
            </button>
            <button
              data-button-type="primary"
              sz="large"
              className="only-show-mobile"
              type="submit"
            >
              {t("feedback.continue")}
            </button>
          </footer>
        </form>
      }
    />
  );
}

const Feedback = (app) => {
  app.get("/feedback", ({ res }) => (res.body = <View />));
};

export default Feedback;
